export default __webpack_public_path__ + "static/media/logo_dark.185be614.png";